import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-56b205ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left flex flex-row p-2 md:h-auto md:flex-col md:border-r-gray-100 md:border-r flex-none overflow-hidden"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-sm w-full text-center hidden md:block"
}, "绘画记录", -1));
const _hoisted_3 = {
  class: "flex md:flex-col h-36"
};
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_img = _resolveComponent("a-img");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_scrollbar, {
    onScroll: _ctx.onscroll,
    ref: "scrollBar"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["item mr-2 md:mr-0 box-border border border-transparent border-2 h-32 w-32 cursor-pointer mt-2 flex-shrink-0 flex-grow-0", {
          'history-active': _ctx.modelValue === index
        }]),
        key: item.renwu_id,
        onClick: $event => _ctx.select(item, index)
      }, [_withDirectives((_openBlock(), _createBlock(_component_a_img, {
        class: _normalizeClass(["w-full h-full object-cover rounded-md", {
          'border border-1 border-r-gray-100': !item.img
        }]),
        src: item.img ? item.img + '?imageView2/1/w/150/h/150' : require('@/assets/default.png'),
        fit: 'cover'
      }, _createSlots({
        _: 2
      }, [item.code === _ctx.TASK_STATUS.CREATED || item.code === _ctx.TASK_STATUS.READY ? {
        name: "loadingText",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(item.jindu || "准备中..."), 1)]),
        key: "0"
      } : undefined]), 1032, ["class", "src"])), [[_directive_loading, item.code === _ctx.TASK_STATUS.CREATED || item.code === _ctx.TASK_STATUS.READY]])], 10, _hoisted_4);
    }), 128))])]),
    _: 1
  }, 8, ["onScroll"])]);
}